<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Wymogi IDD'" [name]="'Zaświadczenia'"></app-breadcrumb>
<div class="idd-training-certificate-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">
    <mat-form-field class="idd-training-certificate-list-filter">
      <mat-label>Rok</mat-label>
      <input type="number" matInput placeholder="2021" name="year" [(ngModel)]="initialFilters.year">
    </mat-form-field>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="idd-training-certificate-list-filter idd-training-certificate-list-filter-long"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-dict-partners
      [multiple]="false" label="Partner"
      class="idd-training-certificate-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict
      [multiple]="false" [dictType]="'idd_certificate_status'"
      [label]="'Status'" class="idd-training-certificate-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <app-datepicker
      class="idd-training-certificate-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="idd-training-certificate-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

  </form>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>
<!--    <div>-->
<!--      <button (click)="generateCertificates()" [disabled]="!(userPermissions | async).idd_training.read_report"-->
<!--              mat-raised-button color="accent"><mat-icon>download</mat-icon> <span> Pobierz zaświadczenia</span></button>-->
<!--    </div>-->
<!--    <div>-->
<!--      <button *ngIf="(userPermissions | async).idd_training.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).idd_training.read_report"-->
<!--              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>-->
<!--    </div>-->
    <div>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    </div>
    <div>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="iddTrainingCertificates" matSort (matSortChange)="sortChanged($event)">

    <ng-container matColumnDef="iddTraining">
      <th mat-header-cell *matHeaderCellDef> Szkolenie IDD </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/szkolenia-idd/szczegoly', element.iddTraining.uuid]">IDD {{element.iddTraining.year}} {{element.iddTraining.ofwca.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.iddTraining.ofwca?.partner" class="default-link" [routerLink]="['/partnerzy/szczegoly', element.iddTraining.ofwca?.partner?.uuid]">{{element.iddTraining.ofwca?.partner?.shortName}}</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.username}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell mat-sort-header="createdAt" *matHeaderCellDef> Data utworzenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status?.color + '-button'">{{element.status?.name}}</button>
      </td>
    </ng-container>


    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button (click)="downloadCertificate(element)"
                [disabled]="!(userPermissions | async).idd_training.write"
                mat-icon-button color="accent"><mat-icon>download</mat-icon></button>
        <button *ngIf="element.status.key !== 'approved' && userPermissionss.idd_training.create" (click)="certificateOverview(element)"
                mat-icon-button color="primary"><mat-icon>add</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
